/**
 * Thrown when an invalid multiaddr is encountered
 */
export class InvalidMultiaddrError extends Error {
  static name = 'InvalidMultiaddrError'
  name = 'InvalidMultiaddrError'
}

export class ValidationError extends Error {
  static name = 'ValidationError'
  name = 'ValidationError'
}

export class InvalidParametersError extends Error {
  static name = 'InvalidParametersError'
  name = 'InvalidParametersError'
}

export class UnknownProtocolError extends Error {
  static name = 'UnknownProtocolError'
  name = 'UnknownProtocolError'
}
